/* noted. — Skipstone club minimum, the sentence a member actually reads.

   Every tier must read "Customized allocations require a minimum purchase of
   $X." Spend is the only minimum. Some members were still being told to select
   a number of bottles, which is not the rule and has not been since 2026-08-21.

   ------------------------------------------------------------------
   WHY SOME MEMBERS SAW THE RIGHT SENTENCE AND OTHERS DID NOT.

   Found by reading the live DOM on two real members, not by reasoning about it.

   The swap in skipstone-portal.js required a parenthetical Awtomic does not
   always print:

     /Select at least \d+ [Bb]ottles?\s*\(\$[\d,]+ min spend\)/i

   Justin's Cave Collector subtitle carries the "min spend" tail, so it matched
   and swapped. David Salmon's Wine Vault subtitle is the bare string

     "Select at least 9 bottles"

   with no tail at all. Tested against all three patterns in that file: no
   match on any of them. It could never have swapped, in any tab, on any load.
   The parenthetical is optional here. The tier is one level up either way.

   SECOND FAULT, same family. That file debounces its rewrite with
   requestAnimationFrame, which does not fire in a background tab. The queued
   flag latches and every later mutation is swallowed. A member opening the
   billing email into a new tab gets no rewrite until they look at it. Same
   fault found tonight in skipstone-bundle-order.js. This file uses a timer.

   ------------------------------------------------------------------
   THE REPLACEMENT IS A FUNCTION, NOT A STRING. THIS IS NOT STYLE.

   The first version of this file passed the sentence as a string, and
   String.replace read the "$1" in "$1,500" as a backreference to capture
   group one. Wine Vault members would have been shown:

     "Customized allocations require a minimum purchase of ,500."

   Cave Collector and Cellar Master were unaffected, because $550 and $3,000
   do not begin with a digit that names a group. So the one tier that breaks is
   the one tier a quick look would not have caught. Caught on a bench test
   across all three tiers before this shipped.

   A function replacement disables $-substitution entirely. The groups are also
   non-capturing now. Either alone would fix it. Both is cheap.
   ------------------------------------------------------------------
   WHY THIS IS NOT AN EDIT TO skipstone-portal.js.

   That file holds the club minimum guard, four days from a 711-member billing
   run. This is additive and cannot regress it.

   The two files cannot fight. Both write the identical sentence, and once
   written it matches none of the patterns in either file. Whichever gets there
   first wins and the other walks past.

   TEXT NODES ONLY. Setting nodeValue is not a child add or remove, so this
   stays inside what Awtomic's React tree tolerates.

   SCRIPT AND STYLE ARE SKIPPED. Awtomic ships inline script on this page.
   Rewriting a string inside their own source is how a copy swap turns into a
   portal stuck on a spinner. That has happened here before.

   IF THE TIER CANNOT BE NAMED, NOTHING IS TOUCHED. Replacing a wrong but
   specific sentence with a vague one helps nobody. Awtomic's original stands.
   ------------------------------------------------------------------ */
(function () {
  "use strict";

  if (window.location.pathname.indexOf("/tools/bundle-subscriptions") === -1) return;

  var SKIP_TAGS = { SCRIPT: 1, STYLE: 1, NOSCRIPT: 1, TEMPLATE: 1, TEXTAREA: 1 };

  /* Every shape Awtomic has been seen to print. The bottle-count tail is
     optional on purpose: that optionality is the whole bug. All groups are
     non-capturing. See the note above on why that matters. */
  var PATTERNS = [
    /Select at least \d+\s+bottles?(?:\s*\(\$[\d,.]*\s*min spend\))?/i,
    /Minimum of \d+\s+bottles?\.?/i,
    /\b\d+\s+items?\s+min\.?/i,
    /Minimum price of \$[\d,.]+ is required for this club\.?/i
  ];

  function tiers() {
    return window.SKIPSTONE_TIERS || {
      "54150225953132": { name: "Cave Collector", bottles: 0, spend: 550 },
      "54150226248044": { name: "Wine Vault", bottles: 0, spend: 1500 },
      "54150226444652": { name: "Cellar Master", bottles: 0, spend: 3000 }
    };
  }

  /* Matches money() in skipstone-portal.js exactly, so the two files produce
     byte-identical sentences. $550, $1,500, $3,000. */
  function money(n) {
    return "$" + Math.round(n).toLocaleString("en-US");
  }

  /* The list page shows every membership at once, so the tier cannot be read
     from the URL. It is read from the words beside the sentence: nearest
     ancestor wins, which is why this walks outward and returns on first hit.
     Verified reaching "Wine Vault" one level up from the subtitle. */
  function tierNear(node) {
    var T = tiers();
    var el = node && node.parentNode;
    for (var i = 0; i < 6 && el; i++) {
      var t = (el.textContent || "").toLowerCase();
      for (var id in T) {
        if (T.hasOwnProperty(id) && t.indexOf(T[id].name.toLowerCase()) !== -1) {
          return T[id];
        }
      }
      el = el.parentElement;
    }
    return null;
  }

  function pass() {
    var w = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, {
      acceptNode: function (node) {
        var p = node.parentNode;
        if (!p || SKIP_TAGS[p.nodeName]) return NodeFilter.FILTER_REJECT;
        if (p.classList && p.classList.contains("skipstone-minimum-note")) {
          return NodeFilter.FILTER_REJECT;
        }
        return NodeFilter.FILTER_ACCEPT;
      }
    });

    var node;
    while ((node = w.nextNode())) {
      var v = node.nodeValue;
      if (!v || v.indexOf("minimum purchase of") !== -1) continue;

      for (var i = 0; i < PATTERNS.length; i++) {
        if (!PATTERNS[i].test(v)) continue;
        var tier = tierNear(node);
        if (!tier) break;
        node.nodeValue = v.replace(PATTERNS[i], function () {
          return "Customized allocations require a minimum purchase of " +
                 money(tier.spend) + ".";
        });
        break;
      }
    }
  }

  function safePass() {
    try { pass(); } catch (e) { console.warn("[skipstone-minimum-copy]", e); }
  }

  var timer = null;
  function schedule() {
    if (timer) return;
    timer = setTimeout(function () { timer = null; safePass(); }, 60);
  }

  function start() {
    try {
      safePass();
      new MutationObserver(schedule).observe(document.body, {
        childList: true, subtree: true, characterData: true
      });
      document.body.addEventListener("click", function () {
        setTimeout(safePass, 200);
      }, true);
      setTimeout(safePass, 1200);
      setTimeout(safePass, 3000);
    } catch (e) {
      console.warn("[skipstone-minimum-copy] disabled", e);
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start);
  } else {
    start();
  }
})();
